import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';

function RowList1({data}) {
    const [showProof, setShowProof] = useState(false)
    const [showProof1, setShowProof1] = useState(false)
    const handleImageClick = () => {
        setShowProof(false);
    }
    const handleImageClick1 = () => {
        setShowProof1(false)
    }

    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const Approve = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ approveVerify: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
                                                                                                                                                                                                                          
    const Decline = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ declineVerify: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Delete = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteVerify: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }

    return (
        <>
        {showProof && (
            <div className="position-fixed d-flex align-items-center justify-content-center oveflow-hidden" style={{width: '350px',height:'500px',borderRadius: '1rem',top: '50%',left: '50%',transform: 'translate(-50%, -50%)', zIndex: '1000',}} onClick={handleImageClick}>
                <img src={`/uploads/${data.id_photo}`} alt="Method" style={{width:'100%',height:'100%',objectFit:'contain'}} />
            </div>
        )}
        {showProof1 && (
            <div className="position-fixed d-flex align-items-center justify-content-center oveflow-hidden" style={{width: '300px',height:'500px',borderRadius: '1rem',top: '50%',left: '50%',transform: 'translate(-50%, -50%)', zIndex: '1000',}} onClick={handleImageClick1}>
                <img src={`/uploads/${data.id_photo1}`} alt="Method" style={{width:'100%',height:'100%',objectFit:'contain'}} />
            </div>
        )}
        <tr className="fw-semibold">
            <td>#{data.id}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td>
                <div className='d-flex align-items-center'>
                    <span>{data.id_card}</span>
                    {data.id_photo && (
                        <div className="d-flex align-items-center justify-content-center rounded-2 ms-2" style={{width: '26px', height: '26px',backgroundColor:'#ffffff0d',cursor:'pointer'}} onClick={() => setShowProof(true)}>
                            <FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} />
                        </div>
                    )}
                    {data.id_photo1 && (
                        <div className="d-flex align-items-center justify-content-center rounded-2 ms-2" style={{width: '26px', height: '26px',backgroundColor:'#ffffff0d',cursor:'pointer'}} onClick={() => setShowProof1(true)}>
                            <FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} />
                        </div>
                    )}
                </div>
            </td>
            <td className='text-nowrap'>{data.date}</td>
            <td
              style={{
                color:
                  data.status === '1'
                    ? 'green'
                    : data.status === ''
                    ? 'red'
                    : 'orange',
              }}
            >
              {data.status === '1'
                ? 'Approved'
                : data.status === ''
                ? 'Declined'
                : 'Pending'}
            </td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                >
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Approve(data.id)}>
                    Approve
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Decline(data.id)}>
                    Decline
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete(data.id)}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        </>
    )
  }
  
  export default RowList1